<template>
  <div class="p-index clearfix">
    <div id="fire" />
    <div class="header center">
      <!-- <i class="logo" /> -->
      <span class="out-href">
        <a href="/index.html" class="towebsite hl">
          <i />
        </a>
        <a target="_blank" href="javascript:;" class="todownload hl _down_client_speed">
          <i />
        </a>
      </span>
      <i class="slogan" />
      <div v-if="islogin" class="u-login loginstatus">
        欢迎您，
        <i v-html="uf.accountname" />
        <em @click="logout()">退出</em>
      </div>
      <div v-else class="u-unlogin loginstatus">
        <em @click="login()">请登录</em>
      </div>
      <div class="choice-btn">
        <span id="btn-dage" :class="{noactive:uf.utype==2}" @click="iamjoin('dage')">
          <i />
          <i />
        </span>
        <span id="btn-getdage" :class="{noactive:uf.utype==1}" @click="iamjoin('follow')">
          <i />
          <i />
        </span>
      </div>
    </div>
    <!-- 大哥推荐榜 -->
    <div class="m1 center">
      <i class="down-arrow" />
      <!-- <i class="flag-mask" /> -->
      <i class="flag" />

      <div class="box1">
        <img class="card-demo br" src="../../images/card.png" width="543" height="346" alt="实例卡片">
        <div class="b1-r">
          <i class="privilege-tit" />
          <ul class="privilege-list">
            <li>唯一编号，终生追随</li>
            <li>专属大哥称号和荣誉勋章</li>
            <li>黑金实物卡专属定制（后期）</li>
            <li>专属大哥坐骑和定制时装</li>
          </ul>
        </div>
        <p class="privilege-tip" />
        <!-- 排行榜 stage为0是初始 1是正式-->
        <i class="box1-mask" />
        <ul class="box1-tjrank wave1">
          <li v-for="(item,index) in rank.dagerank.slice(0,3)" :key="index">
            <span>{{ item.rolename }}</span>
            <!-- <em>{{ item.vipcode }}</em> -->
          </li>
        </ul>
        <ul class="box1-tjrank wave2">
          <li v-for="(item,index) in rank.dagerank.slice(3,7)" :key="index">
            <span>{{ item.rolename }}</span>
            <!-- <em>{{ item.vipcode }}</em> -->
          </li>
        </ul>
        <ul class="box1-tjrank wave3">
          <li v-for="(item,index) in rank.dagerank.slice(7,10)" :key="index">
            <span>{{ item.rolename }}</span>
            <!-- <em>{{ item.vipcode }}</em> -->
          </li>
        </ul>
        <i class="box1-tjrank wave4" />
      </div>
    </div>
    <!-- 活动奖励与规则 -->
    <div class="m2 center">
      <div class="box2">
        <i class="gift-tit" />
        <p class="gift-tip">活动时间：2020年6月1日-6月19日</p>
        <i class="g-tit">活动奖励</i>
        <img class="c br" src="../../images/gift.png">
        <p class="gift-bag-name">
          <i>大哥黑金礼包</i>
          <i>跟大哥上征途礼包</i>
        </p>
        <div class="rule">
          <ul>
            <li>大哥规则：</li>
            <li>1，大哥角色对应的账号登录本活动页面选择“我是大哥”可获得专属唯一黑金卡编号及黑金礼包；</li>
            <li>2，将黑金卡编号发给其他人，可让其成为追随者。</li>
          </ul>
          <ul>
            <li>跟随规则：</li>
            <li>1，符合条件的账号登录本活动页面选择“跟大哥上征途”，输入大哥的黑金卡编号即可跟随成功，成功后不可更换；</li>
            <li>2，跟随大哥成功后即可领取跟随礼包。</li>
          </ul>
          <ul>
            <li>礼包说明：</li>
            <li>1，大哥礼包和跟随礼包随时可领取获得，但2种礼包不可同时兼得；</li>
            <li>2，礼包码与当前登录的账号绑定，需进入游戏内兑换，其他账号不可使用；</li>
            <li>3，此礼包码仅限在6月12日开启的嘉年华新区中使用，其他服务器不可使用；</li>
            <li>4，此礼包码具有时效性，30天后失效，请尽快在游戏内兑换使用，以免过期。</li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 弹框 -->
    <!-- 透明背景 -->
    <div class="cover" :class="{tkActive:layer.cover}" />
    <div class="cover cover2" :class="{tkActive:layer.cover2}" />
    <!-- 不满足条件提示 -->
    <div id="uncondition" class="tk tk-s" :class="{tkActive:layer.uncondition}">
      <i class="close" @click="layerOff('uncondition')" />
      <p>
        对不起，您的账号不满足活动条件，
        <br>无法参与本活动。
      </p>
      <ul>
        <li>参与活动的账号需要满足以下条件</li>
        <li>1、必须为2020年6月1日0时前注册的账号</li>
        <li>2、历史消费大于等于10元的账号</li>
      </ul>
      <a href="javascript:void(0);" class="hl" @click="layerOff('uncondition')" />
    </div>
    <!-- 输入卡号跟随 -->
    <div id="checkdage" class="tk tk-b" :class="{tkActive:layer.checkdage}">
      <i class="close" @click="layerOff('checkdage')" />
      <i class="tit" />
      <div class="center">
        <p>请输入大哥黑金卡号：</p>
        <p>
          <input v-model="followcode" class="import-code" type="text">
          <button class="import-code-btn" @click="checkfollow()">确定</button>
        </p>
        <p>
          * 大哥黑金卡号可向拥有卡号的用户索取
          <br>* 跟随成功后将获得跟随礼包，且跟随成功后不可变更
        </p>
      </div>
      <div class="tk-gift">
        <i class="gift-tit" />
        <img src="../../images/checkdage-gift.png">
      </div>
    </div>
    <!-- 大哥专属黑金卡 -->
    <div id="carddage" class="tk tk-b" :class="{tkActive:layer.carddage}">
      <i class="close" @click="layerOff('carddage')" />
      <i class="tit" />
      <div class="center">
        <div class="l">
          <img :src="uf.dage_data.card_imgurl" width="327" height="207">
          <p class="btn-havapic">
            <a href="api/api.php?c=index&a=download" target="_blank">存图到电脑</a>
            <a href="javascript:void(0);" @mouseenter="showqr" @mouseleave="hideqr">存图到手机</a>
          </p>
          <div id="qrcode" class="qrcodestatus" :class="{active:layer.qrcodeStatus}" />
        </div>
        <div class="r">
          <p>
            当前追随人数：
            <i id="follow-num" v-html="uf.dage_data.followernum">0</i>
          </p>
          <p class="ccb">
            <i>追随邀请专属编码：</i>
            <input v-model="uf.dage_data.vipcode" type="text" class="copy-code">
            <button
              v-clipboard:copy="'兄弟，我是【'+uf.dage_data.dage_name+'】，想体验曾经的国战激情吗？来，这次我带你一起去嘉年华新区爽！输入我的黑金卡号【'+uf.dage_data.vipcode+'】，还能领一份礼包。嘉年华新区，让我们爽起来！'+uf.inviteurl"
              v-clipboard:success="ondageCopy"
              v-clipboard:error="onError"
              class="copy-code-btn hl"
            >复制编码</button>
          </p>
          <p>
            <i class="sns-road">发送编码途径：</i>
            <img src="../../images/tk-card-sns.png" width="317" height="53">
          </p>
        </div>
      </div>
      <div class="bottom">
        <i class="tit" />
        <img src="../../images/carddage-gift.png">
        <i class="getbag hl" @click="layerOn('showcardnum');" />
      </div>
    </div>
    <!-- 追随者已追随弹窗 -->
    <div id="getdage" class="tk tk-b" :class="{tkActive:layer.getdage}">
      <i class="close" @click="layerOff('getdage')" />
      <i class="tit" />
      <div class="l">
        <i class="alone">您当前追随的大哥是:</i>
        <span class="ibox" v-html="uf.follower_data.dage_name" />
        <span class="alone">
          该大哥追随人数：
          <i v-html="uf.follower_data.dage_followernum" />
        </span>
        <i class="alone">您已获得追随礼包码：</i>
        <input v-model="uf.follower_data.card_num" class="ibox secondinput">
        <button
          v-clipboard:copy="uf.follower_data.card_num"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
          class="copy-code-btn hl"
        >复制</button>
      </div>
      <div class="r">
        <div class="gift-list">
          <img src="../../images/getdage-gift.png">
        </div>
      </div>
      <div class="bottom">
        <ul>
          <li>礼包说明：</li>
          <li>1.大哥礼包和跟随礼包随时可领取获得，但2种礼包不可同时兼得；</li>
          <li>2.礼包码与当前登录的账号绑定，需进入游戏内兑换，其他账号不可使用；</li>
          <li>3.此礼包码仅限在6月12日开启的嘉年华新区中使用，其他服务器不可使用；</li>
          <li>4.此礼包码具有时效性，30天后失效，请尽快在游戏内兑换使用，以免过期。</li>
        </ul>
      </div>
    </div>
    <!-- 领取礼包弹框 -->
    <div id="show-cardnum" class="tk show-cardnum" :class="{tkActive:layer.showcardnum}">
      <i class="close" @click="layerOff('showcardnum');" />
      <i class="text">礼包码：</i>
      <input v-model="uf.dage_data.card_num" type="text">
      <button
        v-clipboard:copy="uf.dage_data.card_num"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
        class="copy-code-btn hl"
      />
    </div>
    <!-- 验证进度 -->
    <div id="progressbar" class="tk progressbar" :class="{tkActive:layer.progressbar}">
      <i />
      <span>大哥专属黑金卡生成中，请稍后</span>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import QRCode from 'qrcodejs2'; // 引入qrcode
import gRequire from 'ztgamejs/grequire';

import Firestar from '@norejs/firestar';

export default {
  data() {
    return {
      islogin: 0,
      url: {
        userinfo: 'api/api.php?c=index&a=userinfo',
        dagerank: 'api/api.php?c=index&a=dagerank', // 大哥排行
        verify: 'api/api.php?c=index&a=verify', // 用户认证
        follow: 'api/api.php?c=index&a=follow' // 跟随大哥
      },
      uf: {
        accountname: '',
        utype: '', // 用户类型
        is_joinable: '', // 是否能参加活动
        is_closed: '', // 是否活动已关闭
        tip_close: '', // 活动提示
        verifystatus: '', // 是否已认证
        dage_data: '', // 大哥面板数据
        follower_data: '', // 追随者面板数据
        inviteurl: '', // 复制分享链接
        m_inviteurl: '' // 移动端分享链接
      },
      rank: {
        dagerank: [],
        stage: ''
      },
      followcode: '',
      layer: {
        cover: 0,
        cover2: 0,
        uncondition: 0, // 无条件参加
        checkdage: 0, // 输入跟随码面板
        carddage: 0, // 大哥弹框
        getdage: 0, // 追随者面板
        progressbar: 0, // 进度
        qrcodeStatus: 0, // 存图二维码
        showcardnum: 0
      }
    };
  },
  computed: {}, // 处理一些计算
  created: async function() {
    var GLogin = await gRequire('login/index'); // 引入登录组件

    var _this = this;

    _this.glogin = new GLogin({
      type: 'popup',
      return_url: window.location.href,
      onLogin: function(result) {
        if (!!result && !!result.account) {
          // 登录成功
          // alert(result.account);
          _this.uf.accountname = result.showaccount;
          console.log('登录成功');
          _this.userinfo();
          window.glogin = _this.glogin;
        } else {
          // 登录失败
        }
      },
      onLogout: function(result) {
        if (!!result && !!result.status && result.status > 0) {
          // 注销成功
          // alert('注销成功');
        } else {
          // 注销失败
          // alert(result.msg);
        }
      }
    });
    // _this.userinfo();

    // 大哥排行
    axios
      .get(_this.url.dagerank)
      .then(function(res) {
        _this.rank.dagerank = res.data.list;
        _this.rank.stage = res.data.stage;
      })
      .catch(function(error) {
        console.log(error);
      });
  },
  mounted() {
    Firestar(document.getElementById('fire'), 30, 5);
  },
  methods: {
    userinfo: function() {
      var _this = this;

      axios
        .get(_this.url.userinfo)
        .then(function(res) {
          if (res.data.status === 1) {
            _this.islogin = 1; // 更新登录状态
            // 状态
            console.log('数据初始化');
            _this.uf.utype = res.data.utype; // 用户类型
            _this.uf.is_joinable = res.data.is_joinable; // 是否能参加活动
            _this.uf.is_closed = res.data.is_closed; // 是否活动已关闭
            _this.uf.tip_close = res.data.tip_close; // 活动提示
            _this.uf.verifystatus = res.data.verifystatus; // 是否已认证
            _this.uf.inviteurl = res.data.inviteurl; // 复制分享链接
            _this.uf.m_inviteurl = res.data.m_inviteurl; // 移动端分享链接

            _this.qrcode(); // 生成分享二维码

            // 大哥面板信息
            _this.uf.dage_data = res.data.dage_data;
            // 追随者面板信息
            _this.uf.follower_data = res.data.follower_data;
          } else if (res.data.status === -20) {
            // _this.login();
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    login: function() {
      this.glogin.login();
    },
    logout: function() {
      this.glogin.logout(function() {
        location.reload();
      });
    },
    iamjoin: function(role) {
      if (!this.islogin) {
        this.login();
        return false;
      }
      if (this.uf.is_closed === 1) {
        alert(this.uf.tip_close);
        return false;
      }
      if (this.uf.is_joinable === 0) {
        this.layerOn('uncondition');
        return false;
      }
      if (role === 'dage') {
        let _this = this;
        // 查询是否已经验证，未验证大哥的话，先触发验证流程
        if (this.uf.verifystatus === 0) {
          this.layerOn('progressbar');
          axios
            .get(this.url.verify)
            .then(function(res) {
              if (res.data.status === 1) {
                setTimeout(() => {
                  _this.layerOff('progressbar');
                  _this.layerOn('carddage');
                }, 2000);
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        } else {
          this.layerOn('carddage');
        }
      } else {
        if (this.uf.verifystatus === 0) {
          this.layerOn('checkdage');
        } else {
          this.layerOn('getdage');
        }
      }
    },
    checkfollow: function() {
      let _this = this;

      let followcardid = this.followcode;
      if (followcardid === '') {
        alert('请正确输入大哥黑金卡号!');
      } else {
        axios
          .get(this.url.follow, {
            params: {
              vipcode: followcardid
            }
          })
          .then(function(res) {
            if (res.data.status === 1) {
              _this.userinfo();
              _this.layerOff('checkdage');
              _this.layerOn('getdage');
            } else {
              alert(res.data.msg);
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    qrcode() {
      let _this = this;
      new QRCode('qrcode', {
        width: 138,
        height: 138,
        text: _this.uf.m_inviteurl, // 二维码地址
        colorDark: '#000',
        colorLight: '#fff'
      });
    },
    showqr: function() {
      this.layer.qrcodeStatus = 1;
    },
    hideqr: function() {
      this.layer.qrcodeStatus = 0;
    },
    layerOn: function(name) {
      this.layer[name] = 1;
      if (name === 'showcardnum') {
        this.layer.cover2 = 1;
      } else {
        this.layer.cover = 1;
      }
    },
    layerOff: function(name) {
      this.layer[name] = 0;
      if (name === 'showcardnum') {
        this.layer.cover2 = 0;
      } else {
        this.layer.cover = 0;
      }
    },
    ondageCopy() {
      alert('复制成功！将专属编码发送给其他人，邀请他们成为你的追随者！');
    },
    onCopy(e) {
      alert('复制成功！');
    },
    onError(e) {
      alert('复制失败！');
    }
  }
};
</script>

<style rel="stylesheet/stylus" lang="stylus">
@import '../../assets/stylus/base/_reset.styl'
@import '../../assets/stylus/minixs/_center.styl'
</style>
